import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ChevronDown = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={className} onClick={onClick} ref={ref}>
    <path
      fill="currentColor"
      d="M207 381 13 187c-10-9-10-24 0-34l22-22c10-10 25-10 34-1l155 155 155-155c9-9 24-9 34 1l22 22c10 10 10 25 0 34L241 381c-9 10-25 10-34 0z"
    />
  </svg>
));
